import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Box, Button, Typography } from '@mui/material';
import PageMeta from '../components/PageMeta';

function Home() {
  const navigate = useNavigate();

  return (
    <>
      <PageMeta
        title="Anime Opening Quiz | Play Solo or Multiplayer"
        description="Guess the anime from its opening. Play 508 hand-picked openings in solo or multiplayer mode."
        path="/"
      />
      <Container maxWidth="md">
        <div className="title-header">
          <Typography variant="h3" component="h1">
            Anime Opening Quiz
          </Typography>
        </div>

        <Box className="quiz-container" sx={{ pb: 4 }}>
          <div className="quiz-paper">
            <Box className="landing-page">
              <Typography variant="h4" gutterBottom color="primary" className="main-title">
                Test Your Anime Knowledge!
              </Typography>
              <Typography variant="body1" className="landing-description" color="text.secondary">
                Listen to anime opening clips and guess the correct anime title. 
                Choose between single player or multiplayer mode!
              </Typography>
              
              <Box className="game-mode-section">
                <Button 
                  variant="contained" 
                  size="large" 
                  onClick={() => navigate('/singleplayer')}
                  className="start-game-button"
                >
                  Single Player
                </Button>
                
                <Button 
                  variant="outlined" 
                  size="large" 
                  onClick={() => navigate('/multiplayer')}
                  className="start-game-button"
                >
                  Multiplayer
                </Button>
              </Box>
            </Box>
          </div>
        </Box>

      </Container>
    </>
  );
}

export default Home;
